import styled from "styled-components";

export const PhoneInputContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  border-radius: 3px;
  align-items: center;
  margin-top: 5px;

  :focus-within {
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
  }
`;

export const PhoneInputItem = styled.input`
  padding: 8px;
  font-weight: 400;
  font-size: 12px;
  border: 1px solid #e8e8e8;
  border-left: none;
  border-radius: 0 3px 3px 0;
  width: 120px;

  :focus {
    outline: none;
  }
`;

export const CountryContainer = styled.div`
  display: flex;
  background-color: #f5f5f5;
  width: 80px;
  padding: 7.3px;
  position: absolute;
  left: 0px;
  border-radius: 3px 0 0 3px;
  border: 1px solid #e8e8e8;
  border-right: none;
  align-items: center;
  justify-content: space-evenly;

	:hover {
		cursor: pointer;
	}
`;

export const CountryFlag = styled.img`
  width: 20px;
`;

export const ContryDDI = styled.p`
  font-weight: 400;
  font-size: 10px;
`;

export const CountryIcon = styled.img`
  width: 9px;
`;

export const DropdownContainer = styled.div`
  background-color: #fff;
  width: 200px;
  padding: 10px;
  position: absolute;
  z-index: 99;
  max-height: 200px;
  overflow: scroll;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 6px;
`;

export const Options = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 400;
	padding: 3px;
	justify-content: space-between;

	:hover {
		cursor: pointer;
	}
`;

export const CountryName = styled.p`
  font-weight: 400;
  font-size: 12px;
	width: 100%;
	margin-left: 5px;

`;
